

/**
 * Method that opens a new application page in a new Tab
 * @param {string} page - Page URL, the url that should be appended to the origin 
 */
export const navigateToPageInNewTab = (page) =>
{
        window.open(window.location.origin + page, '_blank', 'noopener,noreferrer');     
}